<template>
    <div id="app" :class="isExchange ? 'bootstrap-hva HVA exchange' : 'bootstrap-hva HVA'">
        <div class="app-content">
            <section :class="['navigation-banner', 'is-unselectable', { 'menu-open': isMobile && showMobileMenu }, { 'compact-banner': isCompact } ]">
                <template v-if="!isMobile && !isCompact">
                    <div :class="['logo-container', logoClass]">
                        <a :href="$i18n.locale == 'nl' ? 'https://www.hva.nl/' : 'https://www.amsterdamuas.com/'">
                            <img :class="['hva-logo', logoClass]" :alt="$i18n.locale == 'nl' ? 'Hogeschool van Amsterdam' : 'Amsterdam University of Applied Sciences'" :src="logoSrc" />
                        </a>
                        <div class="banner-spacer"></div>
                        <router-link :to="{name: 'home'}">
                            <h3 class="pageTitle">{{ pageTitle }}</h3>
                        </router-link>
                    </div>
                    <div class="banner-items">
                        <div class="banner-item" v-for="(item, index) in navbarItems" :key="index">
                            <a :href="item.href" class="banner-link">{{ item.text }}</a>
                        </div>
                        <div v-show="loaded && !isExchange" class="language-selector-dropdown">
                            <span :class="['language-current']" @click="toggleDropdown">{{ $i18n.locale === 'nl' ? 'NL' : 'EN' }}</span>
                            <span class="chevron" :class="{'open': showLanguageDropdown}" @click="toggleDropdown" />
                            <transition name="dropdown">
                            <div v-if="showLanguageDropdown" class="language-dropdown-menu">
                                <div class="language-option" @click.stop="toggleLanguage('nl')">
                                    Nederlands
                                    <img v-if="$i18n.locale === 'nl'" src="../src/images/check.svg" alt="check" class="language-check" />
                                </div>
                                <div class="language-option" @click.stop="toggleLanguage('en')">
                                    English
                                    <img v-if="$i18n.locale === 'en'" src="../src/images/check.svg" alt="check" class="language-check" />
                                </div>
                            </div>
                            </transition>
                        </div>
                    </div>
                </template>
                <template v-else-if="isCompact">                    
                    <div :class="['logo-container', 'logo-compact', logoClass]">
                        <a :href="$i18n.locale == 'nl' ? 'https://www.hva.nl/' : 'https://www.amsterdamuas.com/'">
                            <img :class="['hva-logo', logoClass]" :alt="$i18n.locale == 'nl' ? 'Hogeschool van Amsterdam' : 'Amsterdam University of Applied Sciences'" :src="logoSrc" />
                        </a>
                        <div class="banner-spacer"></div>
                        <router-link :to="{name: 'home'}">
                            <h3 class="pageTitle">{{ pageTitle }}</h3>
                            <transition name="dropdown">
                                <div v-if="showMobileMenu" class="mobile-menu-dropdown">                                                            
                                    <div class="mobile-menu-list">
                                        <div class="mobile-menu-item" v-for="(item, index) in navbarItems" :key="index">
                                            <a :href="item.href" class="banner-link">{{ item.text }}</a>
                                        </div>
                                        <div v-show="loaded && !isExchange" class="language-selector">
                                            <a :class="['language-link', { active: $i18n.locale === 'nl', bold: $i18n.locale === 'nl' }, cooldownClass]" @click="toggleLanguage('nl')">NL</a>
                                            <a :class="['language-link', { active: $i18n.locale === 'en', bold: $i18n.locale === 'en' }, cooldownClass]" @click="toggleLanguage('en')">EN</a>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </router-link>
                    </div>
                    <button class="hamburger-btn hamburger-mobile-btn" @click="showMobileMenu = !showMobileMenu" aria-label="Open menu">
                        <img :src="!showMobileMenu ? require('../src/images/banner-icons/Hamburger.svg') : require('../src/images/banner-icons/ClosePurple.svg')" alt="Menu" class="hamburger-icon" />
                    </button>                    
                </template>
                <template v-else-if="isMobile">
                    <div :class="['logo-container', 'logo-mobile-flex', logoClass]">
                        <a :href="$i18n.locale == 'nl' ? 'https://www.hva.nl/' : 'https://www.amsterdamuas.com/'"><img :class="['hva-logo', logoClass]" :alt="$i18n.locale == 'nl' ? 'Hogeschool van Amsterdam' : 'Amsterdam University of Applied Sciences'" :src="logoSrc" /></a>
                        <button class="hamburger-btn hamburger-mobile-btn" @click="showMobileMenu = !showMobileMenu" aria-label="Open menu">
                            <img :src="!showMobileMenu ? require('../src/images/banner-icons/Hamburger.svg') : require('../src/images/banner-icons/Close.svg')" alt="Menu" class="hamburger-icon" />
                        </button>
                    </div>
                    <transition name="dropdown">
                        <div v-if="showMobileMenu" class="mobile-menu-dropdown">
                            <router-link :to="{name: 'home'}">
                                <h3 class="pageTitle">{{ pageTitle }}</h3>
                            </router-link>
                            <div class="mobile-menu-list">
                                <div class="mobile-menu-item" v-for="(item, index) in navbarItems" :key="index">
                                    <a :href="item.href" class="banner-link">{{ item.text }}</a>
                                </div>
                                <div v-show="loaded && !isExchange" class="language-selector">
                                    <a :class="['language-link', { active: $i18n.locale === 'nl', bold: $i18n.locale === 'nl' }, cooldownClass]" @click="toggleLanguage('nl')">NL</a>
                                    <a :class="['language-link', { active: $i18n.locale === 'en', bold: $i18n.locale === 'en' }, cooldownClass]" @click="toggleLanguage('en')">EN</a>
                                </div>
                            </div>
                        </div>
                    </transition>
                </template>
            </section>
            <ImageBanner :pageTitle="pageTitle" :isExchange="isExchange" :isHomePage="isHomePage"/>
            <section id="view" class="max-width">
                <router-view :key="$route.fullPath" />
                <shareLinkModal v-show="showShareLinkModal" @close="close"></shareLinkModal>
            </section>
            <div class="iefooter"></div>
        </div>
        <div class="footer footerHvA" id="Footer" style="margin-top: 30px;">
            <img src="../src/images/Union.svg" alt="creating tomorrow" class="footer-copyright"/>
            <div class="footer-links">
                <span css="footer-disclaimer"><a href="/disclaimer">{{$t("footer.disclaimer")}}</a></span>
                <span css="footer-privacy"><a href="/privacy">{{$t("footer.privacy")}}</a></span>
            </div>
        </div>
    </div>
</template>
<script>
import shareLinkModal from "@/components/ShareLinkModal.vue";
import ImageBanner from "./components/ImageBanner.vue";
/*eslint-disable */
export default {
    components: {
        shareLinkModal,
        ImageBanner
    },
    data() {
        return {
            showShareLinkModal: false,
            user: null,
            loaded: false,
            pageTitle: "",
            showMobileMenu: false,
            showLanguageDropdown: false
        };
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        getEditorShareUrl() {
            var editorLink = location.protocol + "/" + location.host + "/redactie" + location.pathname;
            var editorInput = document.getElementById("editorLinkInput");
            editorInput.value = editorLink;
            this.showShareLinkModal = true;
        },
        close() {
            this.showShareLinkModal = false;
        },
        toggleLanguage(toggleToLanguage) {
            if (toggleToLanguage == "nl") {
                if (this.isDev) {
                    location.href = "https://dev-studiegids.azurewebsites.net/";
                } else if (this.isAcc) {
                    location.href = "https://acc-studiegids.mijnhva.nl/";
                } else {
                    location.href = "https://studiegids.hva.nl/";
                }
            } else {
                if (this.isDev) {
                    location.href = "https://dev-coursecatalogue.mijnhva.nl/";
                } else if (this.isAcc) {
                    location.href = "https://acc-coursecatalogue.mijnhva.nl/";
                } else {
                    location.href = "https://coursecatalogue.amsterdamuas.com";
                }
            }
        },
        toggleDropdown() {
            this.showLanguageDropdown = !this.showLanguageDropdown;
        },
        closeDropdown() {
            this.showLanguageDropdown = false;
        },
        async checkIfBrowserIsOutdated() {
            await this.$store.dispatch("getBrowserIsOutdated");
            var isBrowserOutdated = this.$store.state.isBrowserOutdated;
                if (isBrowserOutdated && this.$route.path != "/browseroutdated" && (this.userIsProgramEditor || this.userIsProgramFinalEditor || this.userIsCourseEditor || this.userIsCourseFinalEditor)) {
                    this.$router.push({ name: "browseroutdated"})
            }
        },
        handleResize() {
            const width = window.innerWidth;
            this.$store.dispatch('updateIsMobile', width <= 767);
            this.$store.dispatch('updateIsCompact', width >= 768 && width <= 1279);
            if (width > 1279) { 
                this.showMobileMenu = false;
            }
        }
    },
    computed: {
        logoClass() {
            return {
                'mobile-nl': this.isMobile && this.$i18n.locale === 'nl',
                'mobile-en': this.isMobile && this.$i18n.locale === 'en',
                'menu-open': this.isMobile && this.showMobileMenu
            };
        },
        logoSrc() {
            if (this.isMobile && this.$i18n.locale === 'nl') {
                if (this.showMobileMenu) {
                    return require('../src/images/banner-icons/Type=NL Compact, Color=White.svg');
                } else {
                    return require('../src/images/banner-icons/Type=NL Compact, Color=Navy.svg');
                }
            } else if (this.isMobile && this.$i18n.locale === 'en') {
                if (this.showMobileMenu) {
                    return require('../src/images/banner-icons/Type=EN, Color=White.svg');
                } else {
                    return require('../src/images/banner-icons/Type=EN, Color=Navy.svg');
                }
            } else {
                return this.$i18n.locale === 'nl'
                    ? require('../src/images/banner-icons/Type=NL, Color=Navy.svg')
                    : require('../src/images/banner-icons/Type=EN, Color=Navy.svg');
            }
        },
        navbarItems() {
                var navItem = function (css, href, text) {
                    return { css, href, text };
                };
            if (this.$i18n.locale == "en") {
                if (this.isExchange) {
                    return [
                        navItem("mijnhva", "https://start.mijnhva.nl/", "MijnHvA"),
                        navItem("az-lijst", "https://student.amsterdamuas.com/a-z-exchange/az-exchange.html", "AZ List"),
                        navItem("exchange", "https://amsterdamuas.com/exchange", "Exchange"),
                        navItem("sis", "http://sis.hva.nl/", "SIS"),
                        navItem("webmail", "https://webmail.hva.nl/", "Webmail"),
                        navItem("roosters", "http://rooster.hva.nl/", "Timetable")
                    ];
                } else {
                    return [
                        navItem("mijnhva", "https://start.mijnhva.nl/", "MijnHvA"),
                        navItem("az-lijst", "https://student.amsterdamuas.com/a-z-generic/az.html", "AZ List"),
                        navItem("webcolleges", "http://www.hva.nl/webcolleges", "Web Lectures"),
                        navItem("sis", "http://sis.hva.nl/", "SIS"),
                        navItem("webmail", "https://webmail.hva.nl/", "Webmail"),
                        navItem("roosters", "http://rooster.hva.nl/", "Timetable")
                    ];
                }
            } else {
                return [
                    navItem("mijnhva", "https://start.mijnhva.nl/", "MijnHvA"),
                    navItem("az-lijst", "https://student.hva.nl/studenten-algemeen/a-z.html", "AZ Lijst"),
                    navItem("webcolleges", "http://www.hva.nl/webcolleges", "Webcolleges"),
                    navItem("sis", "http://sis.hva.nl/", "SIS"),
                    navItem("webmail", "https://webmail.hva.nl/", "Webmail"),
                    navItem("roosters", "http://rooster.hva.nl/", "Roosters")
                ];
            }
        },
        cooldownClass() {
            return this.cooldown ? "cooldown" : "";
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        isCompact() {
            return this.$store.getters.isCompact;
        },
        isHomePage() {
        return this.$route.name === 'home' || this.$route.name === 'homeDeepLinked';        
        }
    },
    async created() {
        this.pageTitle = document.title;
        this.$store.commit("initializeStore");
        await this.$store.dispatch("getRoles");
        await this.checkIfBrowserIsOutdated();
        this.$store.dispatch("getAcademicYears");
        this.loaded = true;
    }
};
</script>

<style lang="less" scoped>

.logo-mobile-flex {
    flex: 1;
    justify-content: space-between;
    display: flex;
    align-items: center;
}

.hamburger-mobile-btn {
    background: none;
    border: none;
    padding: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
}

.hamburger-icon {
    width: 32px;
    height: 32px;
    display: block;
}
h3.pageTitle {
    margin-bottom: 0;
    text-decoration: underline;
    text-decoration-thickness: 3px;
	text-underline-offset: 10px;
    font-size: 14px;
    font-weight: 700;
}

.navigation-banner .router-link-active {
    text-decoration: none;
}

a.cooldown {
    color: #333 !important;
}

#app {
    position: relative;
    display: flex;
    min-height: 100vh;
    height: 100%;
    flex-direction: column;

    .app-content {
        flex: 1;
    }
}

.title-language {
    display: flex;
    justify-content: space-between;
}

.language {
    margin: 10px 18px 8px 8px;
    margin-bottom: unset;
    font-size: 16px;
    width: 100px;
    text-align: right;
    cursor: pointer;
}

#hva {
    padding: 20px 10px 20px 20px;
    display: flex;
    justify-content: space-between;
}

.hero {
    margin: 0px auto;
    min-height: 55px;
    max-height: 700px;
    overflow: hidden;

    .banner {
        z-index: 2;
        position: absolute;
        height: 55px;
        width: 100%;
        background-color: rgb(37, 22, 122);

        nav {
            display: grid;
            display: -ms-grid;
            grid-template-columns: repeat(2, minmax(20px, 55px)) 0px repeat(6, minmax(20px, 55px));
            -ms-grid-columns: 55px 55px 55px 55px 55px 55px 55px 55px 55px;
            grid-template-rows: 55px;
            -ms-grid-rows: 55px;

            > :nth-child(1) { -ms-grid-row: 1; -ms-grid-column: 1; }
            > :nth-child(2) { -ms-grid-row: 1; -ms-grid-column: 2; }
            > :nth-child(3) { -ms-grid-row: 1; -ms-grid-column: 3; }
            > :nth-child(4) { -ms-grid-row: 1; -ms-grid-column: 4; }
            > :nth-child(5) { -ms-grid-row: 1; -ms-grid-column: 5; }
            > :nth-child(6) { -ms-grid-row: 1; -ms-grid-column: 6; }
            > :nth-child(7) { -ms-grid-row: 1; -ms-grid-column: 7; }
            > :nth-child(8) { -ms-grid-row: 1; -ms-grid-column: 8; }
            > :nth-child(9) { -ms-grid-row: 1; -ms-grid-column: 9; }
        }

        .banner-item {
            text-align: center;
            position: relative;

            @banner-icons: studiegids, roosters, webmail, sis, webcolleges, az-lijst, mijnhva, exchange;
            each(@banner-icons, {
                .@{value} {
                    background-image: %(~"url(../src/images/banner-icons/%a.svg)", @value);
                }
            });
            a {
                padding-top: 30px;
                display: block;
                text-transform: uppercase;
                color: white;
                overflow: hidden;
                font-size: 7px;
                font-weight: 600;
                height: 50px;
                min-width: 30px;
                max-width: 85px;
                background-repeat: no-repeat;
                background-position: center 7px;
                background-size: 25px auto;
                line-height: 22px;
                text-align: center;
                opacity: 0.7;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }
}

#view {
    position: relative;
}

.footer {
    padding: 40px;
    background-color: black;
}

//modifications for desktop
@media only screen and (max-width: 767px) {
    .hero .banner nav {
        -ms-grid-columns: 55px 0 0 55px 55px 55px 55px 55px 55px;
    }
}

@media only screen and (min-width: 768px) {
    #hva {
        .language {
            font-size: initial;
        }
    }

    .hero {
        .banner {
            background-color: rgba(37, 22, 122, 0.7);

            nav {
                grid-template-columns: repeat(2, minmax(55px, auto)) 1fr repeat(6, minmax(55px, auto));
                grid-column-gap: 10px;
                padding: 0px 10px;
            }

            .banner-item {
                &:first-child::after {
                    content: " ";
                    position: absolute;
                    left: 4px;
                    bottom: -20px;
                    width: 46px;
                    height: 20px;
                    margin: 0;
                    z-index: 1;
                    background: url(../src/images/nav-arrow.svg) no-repeat 0 0;
                }

                a {
                    font-size: 8px;
                }
            }
        }

        .banner-image {
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: center;
            width: 100vw;
            img {
                object-fit: cover;
            }
        }
        .banner-fade {
            display: block;
            position: relative;
        }
        .banner-fade::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: url(../src/images/image-fade.svg) no-repeat;
            background-position: center 0;
        }
    }
}

.navigation-banner {
    display: flex;
    align-items: center;
    padding: 24px 40px;
    gap: 40px;
    justify-content: space-between;
    overflow: hidden;
    background: white;
    transition: background 0.4s cubic-bezier(0.4,0,0.2,1);
    max-width: 1600px;
    margin: auto;
}

.navigation-banner.compact-banner {
    align-items: flex-start;
}

.navigation-banner.compact-banner .hamburger-btn {
    margin-top: 4px;
}

.navigation-banner.menu-open {
    background: #351FB7;
    transition: background 0.4s cubic-bezier(0.4,0,0.2,1);
}

.logo-container {
    display: flex;
    align-items: center;
}

.logo-container.logo-compact {
    align-items: flex-start;

    h3 {
        margin-top: 8px;
    }
}

.logo-container.logo-mobile-flex {
    align-items: flex-start;
}

.banner-spacer {
    width: 40px;
}

.banner-items {
    gap: 24px;
    display: flex;
    align-items: center;
}

.banner-item .banner-link {
    white-space: nowrap;
    width: auto;
    padding: 0 12px;
}

a.banner-link,
.language-selector-dropdown *,
.language-selector .language-link {
    font-size: 14px;
}

.banner-title-block-container {
    display: flex;
    flex: 1;
    align-items: center;
    background-color: #25167A;
    width: 100%;
    aspect-ratio: 0.96 / 1;
}

.banner-title-block {
    padding: 32px;
}

.banner-image .image-wrapper {
    flex: 2;
}

.banner-image {
    width: 100vw;
    aspect-ratio: 2.88 / 1;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.banner-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.language-current,
.language-option {
    cursor: pointer;
    color: #351FB7;
}

.language-selector,
.chevron,
.language-option {
    cursor: pointer;
    caret-color: transparent;    
}

.language-option:not(:first-of-type){
    margin-top: 16px;
}

.language-option:hover {
    text-decoration: underline;
}

.language-selector:hover{
    color: #0056b3;
    text-decoration: underline;
}

.language-dropdown-menu {
    z-index: 100;
    position: absolute;
    right: 40px;
    background: white;
    min-width: 140px;
    padding: 16px;
}

@media(min-width:1600px) {
    .language-dropdown-menu {
        right: calc(40px + (100vw - 1600px) / 2);
    }
}

.language-check {
    width: 16px;
    height: 16px;
    margin-left: 8px;
}

.language-option:hover .language-check {
    filter: invert(41%) sepia(98%) saturate(749%) hue-rotate(314deg) brightness(97%) contrast(92%);
}       

.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 300ms ease;
}

.dropdown-enter,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

.mobile-menu-list {
    margin-top: 24px;
}

@media (min-width: 768px) and (max-width: 1279px) {
    .hamburger-mobile-btn {
        margin: unset;    
    }

    .mobile-menu-item {
        margin-bottom: 18px;
    }

    .language-selector {
        display: flex;
        justify-content: space-between;
    }

    .language-selector:hover {
        text-decoration: unset;
    }
}

@media only screen and (max-width: 767px) {
    .banner-image {
        flex-direction: column !important;
        flex-wrap: nowrap;
        width: 100vw !important;
        aspect-ratio: unset;
        align-items: stretch !important;
    }
    .banner-title-block-container {
        aspect-ratio: unset !important;
    }
    .banner-title-block {
        width: 100%;
    }
    .image-wrapper {
        position: relative;
        overflow: hidden;
    }
    .banner-image img {
        width: 100%;
        height: 53vw;
        object-fit: cover;
        object-position: center;
        display: block;
    }

    .navigation-banner {
        padding:18px;
    }

    .hamburger-btn {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .mobile-menu-dropdown {
        position: absolute;
        top: 70px;
        left: 0;
        right: 0;
        background: #351FB7;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        padding: 16px 0;
    }

    .mobile-menu-dropdown.menu-open {
        background: #351FB7;
    }

    .mobile-menu-dropdown {
        padding: 40px 18px 18px 18px;
        gap: 64px;
    }

    .mobile-menu-dropdown h3 {
        color: white;
    }

    .mobile-menu-list {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .mobile-menu-item:last-child {
        border-bottom: none;
    }

    .language-selector {
        display: flex;
        gap: 40px;
    }

    .language-selector .language-link {
        font-weight: normal;
        cursor: pointer;
        color: inherit;
    }

    .language-selector .language-link.active {
        text-decoration: underline;
        text-underline-offset: 5px;
        text-decoration-thickness: 2px;
        font-weight: bold;
        cursor: default;
    }

    .mobile-menu-item a,
    .language-selector a {
        color: white !important;
    }

    .footer.footerHvA {
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: 40px;       
    }

    .footer.footerHvA .footer-links {
        display: flex;
        flex-direction: column;  
        gap: 16px;
    }
    
}
</style>

<style type="text/css">
span.footer-copyright {
    float: left;
}
/* Footer */
.footer {
    padding: 0 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #666;
    float: left;
    width: 100%;
    background-color: #f2f2f2;
    box-sizing: border-box;
    font-family: OpenSans Regular,Segoe UI,Segoe,Tahoma,Helvetica,Arial,sans-serif;
    font-weight: 400;
    line-height: 1.5;
}
.iefooter {
    display: none;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    .footer {
        bottom: 0;
        position: fixed;
        z-index: 50;
    }
    .iefooter {
        display: block;
        height: 44px;
    }
}

.footer-links {
    float: right;
    display: flex;
    gap: 40px;
}

.footer-links a {
    text-decoration: none;
}

.footer-links a:hover {
    text-decoration: underline;
}

.language-selector {
    color: #351FB7;
}

@media (max-width: 767px) {
    .footer-copyright {
        height: 24px;
    }
}
</style>
